export default () => ({
  availabilityGallery: null,
  availabilityGallerySvgData: null,
  priceTags: [],
  selectedPaymentMethodId: undefined,
})
